<sz-app-shell>
  <sz-top-bar />

  <div class="drill-create">
    <sz-page-title
      [title]="'drills.create.title' | translate"
      [accent]="'drills.create.accent' | translate"
      size="xl"
      [showBack]="true" />
    <lib-drill-form [initialValue]="initialValue" (formSubmit)="onSubmit($event)" />
  </div>

  <sz-cta-bar variant="floating">
    <sz-button variant="primary" [fullWidth]="true" [disabled]="!canSubmit()" (click)="triggerSubmit()">
      <sz-icon name="check" [size]="16" />
      {{ 'drills.create.cta' | translate }}
    </sz-button>
  </sz-cta-bar>
</sz-app-shell>
